import React from "react";
import AdminAddCity from "../../Components/Admin/AdminAddCity";
import SideBar from "../../Components/Admin/SideBar";

const AdminAddCityPage = ()=>{
    return (
      <AdminAddCity />
    )
}

export default AdminAddCityPage;